var alignment_rtlignore_default = {
  "alignLeft": "_52849",
  "textWrapNowrap": "Z18S7",
  "alignRight": "_6KMA6",
  "alignCenter": "uoD-B",
  "sizeFullWidth": "N3C96",
  "renderedInTable": "_35e8e",
  "sizeOriginal": "HLrFc",
  "sizeContent": "_6Dfd4",
  "sizeSmall": "nnUUo",
  "sizeSmallCenter": "_3sp8l",
  "flex": "FecTP",
  "LEFT": "Oh0KO",
  "CENTER": "_9RrG6",
  "RIGHT": "yQpHH",
  "AUTO": "RT-Ph",
  "JUSTIFY": "UN-rl"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
